/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

export default safeGet;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_safeGet.js
// module id = ./node_modules/lodash-es/_safeGet.js
// module chunks = 1